import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  EventsSubscriptionDetails,
  EventsSubscriptionListItem,
  GetEventsSubscriptionsListRequest
} from './types';
import { PaginationV2 } from 'src/types';
import * as thunks from './thunks';

interface State {
  events: EventsSubscriptionListItem[];
  meta: PaginationV2;
  isLoading: boolean;
  filters: GetEventsSubscriptionsListRequest;
  voucherSpecs: string | null;
  eventDetails: EventsSubscriptionDetails | null;
}

const initialState: State = {
  meta: {},
  filters: {},
  events: [],
  isLoading: false,
  voucherSpecs: null,
  eventDetails: null
};

const slice = createSlice({
  name: 'event-subscriptions',
  initialState,
  reducers: {
    setFilters(
      state,
      { payload }: PayloadAction<GetEventsSubscriptionsListRequest>
    ) {
      state.filters = { ...state.filters, ...payload };
    },
    setVoucherSpecs(state, { payload }: PayloadAction<string>) {
      state.voucherSpecs = payload;
    }
  },
  extraReducers(builder) {
    // get list
    builder.addCase(thunks.getEventSubscriptionsListThunk.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(thunks.getEventSubscriptionsListThunk.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(
      thunks.getEventSubscriptionsListThunk.fulfilled,
      (state, { payload }) => {
        state.events = payload?.originalData?.data || [];
        state.meta = payload?.originalData?.meta || {};
        state.isLoading = false;
      }
    );

    // get details
    builder.addCase(
      thunks.getEventSubscriptionDetailsThunk.pending,
      (state) => {
        state.isLoading = true;
      }
    );
    builder.addCase(
      thunks.getEventSubscriptionDetailsThunk.rejected,
      (state) => {
        state.isLoading = false;
      }
    );
    builder.addCase(
      thunks.getEventSubscriptionDetailsThunk.fulfilled,
      (state, { payload }) => {
        state.eventDetails = payload?.originalData?.data || null;
        state.isLoading = false;
      }
    );
  }
});

export const reducer = slice.reducer;
export const actions = { ...slice?.actions, ...thunks };
